module.exports = __webpack_public_path__ + "static/img/title.01cb6d3.8a09e2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live/title.01cb6d3.png
// module id = I2w7
// module chunks = 56